module.exports = __webpack_public_path__ + "img/LS20130912_greenfire_021.4816b8c1.jpg";